interface PlayerAvatarProps {
  src: string | undefined
}

export const PlayerAvatar = ({ src }: PlayerAvatarProps) => {
  return (
    <div className="inline-flex size-[38px] min-w-[38px] max-w-[38px] items-center justify-center overflow-hidden rounded-full bg-fg-primary">
      <img src={src || '/icons/default-avatar.svg'} className="block size-full bg-transparent" alt="" />
    </div>
  )
}
